__turbopack_context__.v({
  "button": "expanding-plus-button-module-scss-module__mk7E7W__button",
  "close-icon": "expanding-plus-button-module-scss-module__mk7E7W__close-icon",
  "open-icon": "expanding-plus-button-module-scss-module__mk7E7W__open-icon",
});
